// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Route from "../Route.bs.js";
import * as React from "react";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Patreon from "./Patreon.bs.js";
import * as $$Promise from "common/src/Promise.bs.js";
import * as DiscordSvg from "common/src/components/DiscordSvg.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as LocalStorage from "common/src/LocalStorage.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import Button from "@mui/material/Button";

var redirect = ((path) => window.location.replace(path));

function getPatreonStatus(param) {
  var v = LocalStorage.get("p-status");
  if (!(v == null)) {
    return Caml_option.some(JSON.parse(v));
  }
  
}

function setPatreonStatus(typ, expires) {
  return LocalStorage.set("p-status", Belt_Option.getExn(JSON.stringify([
                      typ,
                      expires
                    ])));
}

function PatreonPage(Props) {
  var match = React.useState(function () {
        
      });
  var setPs = match[1];
  var patreonStatus = match[0];
  var basePath = CdnAtom.usePath(undefined);
  React.useEffect((function () {
          Curry._1(setPs, (function (param) {
                  return getPatreonStatus(undefined);
                }));
          var url = RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined);
          var search = Js_dict.fromArray(Route.parseQs(url.search));
          var code = Js_dict.get(search, "code");
          if (code !== undefined) {
            var uid = Belt_Option.getWithDefault(Caml_option.nullable_to_opt(LocalStorage.get("uid")), "");
            $$Promise.consume2(Patreon.fetchApi(code, uid), (function (resp) {
                    if (resp.authorized) {
                      LocalStorage.set("afmt", "yay");
                      setPatreonStatus(resp.typ, resp.expires);
                      Curry._1(setPs, (function (param) {
                              return [
                                      resp.typ,
                                      resp.expires
                                    ];
                            }));
                      return redirect("/patreon");
                    }
                    
                  }), (function (err) {
                    console.log(err);
                    
                  }));
          }
          
        }), []);
  var tmp;
  if (patreonStatus !== undefined) {
    var tier;
    switch (patreonStatus[0]) {
      case "master-tactician" :
          tier = "Master Tactician";
          break;
      case "tactician" :
      case "tactician?" :
          tier = "Tactician";
          break;
      default:
        tier = "Unknown";
    }
    tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
              className: "pb-6"
            }, "Patreon connected successfully. Thank you for your support."), React.createElement("div", {
              className: "pb-6"
            }, "Subscribed to ", React.createElement("span", {
                  className: "font-montserrat font-semibold"
                }, tier), " tier."), React.createElement("div", {
              className: "block"
            }, "Be sure to join the tactics.tools Discord for the most recent information about your Patreon benefits with tactics.tools."), React.createElement("div", {
              className: "flex font-montserrat items-center font-semibold pt-2 gap-10"
            }, React.createElement("a", {
                  className: "flex items-center gap-1 text-primary-11 cursor-pointer mt-[1px]",
                  href: "https://discord.gg/K4Z6shucH8",
                  target: "_blank"
                }, React.createElement(DiscordSvg.make, {
                      size: 24
                    }), "Join tactics.tools Discord"), React.createElement("a", {
                  className: "block cursor-pointer text-primary-11",
                  href: "https://support.patreon.com/hc/en-us/articles/212052266-Get-my-Discord-role"
                }, "How to connect Discord to Patreon")), React.createElement("div", {
              className: "leading-snug pb-2 pt-10"
            }, "If there is something wrong with your integration, try to reconnect to your Patreon. If you are still having issues, report them to #bugs channel on the Discord."), React.createElement("a", {
              href: "https://www.patreon.com/oauth2/authorize?response_type=code&client_id=gJaB7PTVB8g5m1PSHUxjK7-0lQWn1pBaKNdVt7KopGHIX66id9PNlRqyeJADAnTr&redirect_uri=https://tactics.tools/patreon&scope=identity"
            }, React.createElement(Button, {
                  onClick: (function (param) {
                      
                    }),
                  variant: "contained",
                  color: "secondary",
                  size: "small",
                  children: null
                }, React.createElement("img", {
                      height: "18",
                      src: basePath + "/general/patreon.png?width=18",
                      width: "18"
                    }), React.createElement("span", {
                      className: "ml-2"
                    }, "Reconnect with Patreon"))));
  } else {
    tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
              className: "pb-6"
            }, React.createElement("div", undefined, React.createElement("div", {
                      className: "pb-3 leading-snug"
                    }, "You can now support development and maintenance of tactics.tools via Patreon. Supporters receive benefits like the Advanced Explorer which provides more advanced and unlimited filtering options along with an ad-free site wide viewing experience."), React.createElement("a", {
                      href: "https://patreon.com/tactics_tools",
                      target: "_blank"
                    }, React.createElement(Button, {
                          onClick: (function (param) {
                              
                            }),
                          variant: "contained",
                          color: "secondary",
                          size: "small",
                          children: null
                        }, React.createElement("img", {
                              height: "18",
                              src: basePath + "/general/patreon.png?width=18",
                              width: "18"
                            }), React.createElement("span", {
                              className: "ml-2"
                            }, "Support tactics.tools on Patreon"))))), React.createElement("div", {
              className: "pb-3 leading-snug"
            }, "Once you're contributing to Patreon connect to your patreon below to enable patreon features."), React.createElement("a", {
              href: "https://www.patreon.com/oauth2/authorize?response_type=code&client_id=gJaB7PTVB8g5m1PSHUxjK7-0lQWn1pBaKNdVt7KopGHIX66id9PNlRqyeJADAnTr&redirect_uri=https://tactics.tools/patreon&scope=identity"
            }, React.createElement(Button, {
                  onClick: (function (param) {
                      
                    }),
                  variant: "contained",
                  color: "secondary",
                  size: "small",
                  children: null
                }, React.createElement("img", {
                      height: "18",
                      src: basePath + "/general/patreon.png?width=18",
                      width: "18"
                    }), React.createElement("span", {
                      className: "ml-2"
                    }, "Connect with Patreon"))));
  }
  return React.createElement(ContentSection.make, {
              className: "mx-auto my-8 max-w-[600px]",
              children: tmp
            });
}

var make = PatreonPage;

export {
  redirect ,
  getPatreonStatus ,
  setPatreonStatus ,
  make ,
  
}
/* Route Not a pure module */
